export const PURCHASE_RETURN_REGISTER_REPORT_REQUEST = 'PURCHASE_RETURN_REGISTER_REPORT_REQUEST';
export const PURCHASE_RETURN_REGISTER_REPORT_SUCCESS = 'PURCHASE_RETURN_REGISTER_REPORT_SUCCESS';
export const PURCHASE_RETURN_REGISTER_REPORT_FAILURE = 'PURCHASE_RETURN_REGISTER_REPORT_FAILURE';